export default __webpack_public_path__ + "static/logo-welireg-white-f1671ec0059fd5c09d89b507e3012a9c.svg";